export default {
      id: "close-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "img/icons.svg#close",
      toString: function () {
        return this.url;
      }
    }